/**
 * Decode HTML entities from API titles (e.g. &#8211; → –).
 */
export function decodeHtmlEntities(text: string | null | undefined): string {
  if (!text) return '';
  if (typeof document === 'undefined') {
    return text
      .replace(/&#(\d+);/g, (_, n) => String.fromCharCode(Number(n)))
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#8211;/g, '–')
      .replace(/&#8212;/g, '—');
  }
  const el = document.createElement('textarea');
  el.innerHTML = text;
  return el.value;
}

/**
 * Strip a leading indicator code when shown beside acf.index (UN 1.1.1 or EU sdg_01_20).
 */
export function stripLeadingIndicatorCode(
  title: string | null | undefined,
  code?: string | null
): string {
  let t = decodeHtmlEntities(title || '').trim();
  const c = (code || '').trim();
  if (!t) return '';
  if (c && t.toLowerCase().startsWith(c.toLowerCase())) {
    t = t.slice(c.length).replace(/^[\s·–\-:]+/, '').trim();
  }
  t = t.replace(/^sdg_\d{2}_\d{2}[a-z]?\s*[\·–\-]\s*/i, '').trim();
  t = t.replace(/^\d+(?:\.[0-9a-z]+)*\s*[·–\-]\s*/i, '').trim();
  return t;
}

/**
 * Build a display title with code prefix once (no duplication).
 */
export function indicatorTitleWithCode(
  title: string | null | undefined,
  code?: string | null
): string {
  const clean = stripLeadingIndicatorCode(title, code);
  const c = (code || '').trim();
  if (c && clean) return `${c} · ${clean}`;
  return clean || c || decodeHtmlEntities(title || '');
}
